export default "/images/ic-arrow-right.svg?c131c251f9ba01b431a58431629157d5";